import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdatePackage($companyId: ID!, $id: ID!, $attributes: PackageAttributes!) {
    updatePackage(companyId: $companyId, id: $id, attributes: $attributes) {
      package {
        id
        ...UpdatedPackage
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedPackage on Package {
    id
    name
    rateCents
    displayOnWebsite
    availableToEvents
    description
  }
`
